import { DateTimeIso8601Local_Schema, WholeNumber_Schema } from "@/utilities";
import { MarketplaceItemId_Schema } from "./marketplaceItemSchema";
import { z } from "zod";

export const MarketplaceItemBasics_Schema = z
  .object({
    id: MarketplaceItemId_Schema,
    name: z.string(),
    quantity: WholeNumber_Schema,
    expiresAt: DateTimeIso8601Local_Schema,
  })
  .transform(({ expiresAt, ...rest }) => ({
    ...rest,
    dateTimeExpiration: expiresAt,
  }));
